<h2 class="sr-only">Decline reason mapping tool — map portal-specific decline reasons to standardized categories</h2>
<admin-breadcrumbs></admin-breadcrumbs>
<div *ngIf="loading" class="state-msg">Loading…</div>
<div *ngIf="loadError" class="state-msg state-msg--error">{{ loadError }}</div>

<div *ngIf="!loading && !loadError" class="drm-shell">
  <div class="map-wrap">
    <div class="map-header">
      <div>
        <div class="map-title">Decline reason mapping</div>
        <div class="map-sub">{{ state.rows.length }} categories · {{ state.totalMappedCount }} portal reasons mapped</div>
      </div>
      <div class="hdr-btns">
        <button type="button" (click)="addRow()">+ Add category</button>
        <button type="button" [disabled]="saving" (click)="save()">{{ saving ? 'Saving…' : 'Save' }}</button>
      </div>
    </div>

    <ng-container *ngIf="state.rows.length === 0; else gridBlock">
      <div class="empty-state">No categories yet. Click "+ Add category" to get started.</div>
    </ng-container>
    <ng-template #gridBlock>
      <div class="drm-grid-wrap">
        <ag-grid-angular
          class="ag-theme-alpine drm-ag"
          style="width: 100%; height: 100%"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [context]="gridContext"
          [getRowId]="getRowId"
          [suppressCellFocus]="true"
          [columnHoverHighlight]="true"
          [suppressRowHoverHighlight]="true"
          [animateRows]="false"
          (gridReady)="onGridReady($event)"
        >
        </ag-grid-angular>
      </div>
    </ng-template>

    <div class="panel" *ngIf="state.activeCell && state.activeRow && state.activePortal">
      <div class="panel-hdr">
        <div class="panel-label">
          {{ state.activeRow.name }}
          <span class="panel-arrow">→</span>
          {{ state.activePortal.name }}
        </div>
        <div class="panel-right">
          <span class="panel-count">{{ state.activeSelectedReasons.length }} selected</span>
          <button type="button" (click)="closePanel()">Close</button>
        </div>
      </div>
      <div class="chips">
        <div
          *ngFor="let reason of state.activePortalReasons"
          class="chip"
          [class.chip-sel]="state.activeSelectedReasonSet.has(reason)"
          [class.chip-taken]="state.activeTakenSet.has(reason)"
          [attr.title]="chipTitle(reason)"
          (click)="onChipClick(reason)"
        >
          <span>{{ reason }}</span>
          <span class="chip-mapped" *ngIf="state.activeTakenSet.has(reason)">mapped</span>
        </div>
      </div>
    </div>

    <div class="legend" *ngIf="!state.activeCell">
      <span class="legend-item">
        <span class="leg-dot leg-dot--info"></span>
        Click any portal cell to open mapping panel
      </span>
      <span class="legend-item">
        <span class="leg-dot leg-dot--muted"></span>
        Grayed reasons are already mapped to another category
      </span>
    </div>
  </div>
</div>

<div class="toast" [class.toast--visible]="!!toastMessage" [class.toast--success]="toastType === 'success'" [class.toast--error]="toastType === 'error'">{{ toastMessage }}</div>

<div *ngIf="confirmDeleteRowId" class="drm-confirm-backdrop" (click)="cancelDeleteConfirm()">
  <div class="drm-confirm-dialog" (click)="$event.stopPropagation()">
    <p class="drm-confirm-title">Are you sure?</p>
    <p class="drm-confirm-msg">
      Deleting this category will leave all the decline reasons attached to it without a category,
      which might lead to overcrowded reports.
    </p>
    <div class="drm-confirm-actions">
      <button type="button" class="drm-confirm-btn drm-confirm-btn--yes" (click)="confirmDelete()">Yes</button>
      <button type="button" class="drm-confirm-btn drm-confirm-btn--no" (click)="cancelDeleteConfirm()">No</button>
    </div>
  </div>
</div>
